import { useContext } from "react";
import { Context } from "../context/device";
import { BREAKPOINTS_DETAILED, BREAKPOINTS } from "../constants/breakpoints";
export const useDevice = () => {
    const { device: deviceState } = useContext(Context);
    const deviceWidth = deviceState.width || 0;
    const deviceDetailed = Object.keys(BREAKPOINTS_DETAILED).find((key) => deviceWidth <=
        (BREAKPOINTS_DETAILED
            ? BREAKPOINTS_DETAILED[key]
            : 0)) || "desktop_l";
    const device = Object.keys(BREAKPOINTS).find((key) => deviceWidth <=
        (BREAKPOINTS ? BREAKPOINTS[key] : 0)) || "desktop";
    return {
        type: device,
        typeDetailed: deviceDetailed,
        width: deviceWidth,
    };
};
